/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { EntityTypeValue } from '@pwc/pwc-deals-web-common';
import {
  selectAnalysisContent,
  selectDraftVersion,
} from '../../features/analyses/analysisSlice';
import { getFreeformAnalysisSelector } from '../../features/analyses/editFreeformAnalysisSlice';
import { kfaContentId } from '../../features/hypotheses/hypothesisSlice';
import { getEntityType } from '../../features/comments/commentsSlice';

export const useAnalysesContentId = (): number | null => {
  const kfaContentIdentifier = useSelector(kfaContentId);
  const entityType = useSelector(getEntityType) as EntityTypeValue;

  const isKfa = entityType === 'hypothesis';

  const { analysis: analysisEdit } = useSelector(getFreeformAnalysisSelector);
  const analysisContent = useSelector(selectAnalysisContent);
  const draftVersion = useSelector(selectDraftVersion);
  const location = useLocation();
  const isEditPage = location.pathname.endsWith('edit');

  /**
   * analysisContent => Has the content Id in View Mode
   * analysisEdit => Has the content ID in Edit mode. Also has similar content Id in draftVersion
   * draftVersion => When the user is in Client Mode and Clicks on Edit only the draft Version has the Updated Version. After the user clicks on Done analysisEdit gets updated
   */

  if (
    (isKfa && kfaContentIdentifier) ||
    analysisContent ||
    draftVersion ||
    (analysisEdit && isEditPage)
  ) {
    const contentId = (isKfa && kfaContentIdentifier) ||
      analysisContent?.contentId ||
      draftVersion?.contentId ||
      analysisEdit?.contentId || { contentId: null };

    if (contentId) {
      return Number(contentId);
    }
  }
  return null;
};
